import { Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { GroupsService } from '../../services/groups.service';
import { LocalService } from '../../services/local.service';
import { SidenavService } from '../../services/sidenav.service';
import { StandingsService } from '../../services/standings.service';

@Component({
  selector: 'app-stats-evolution',
  templateUrl: './stats-evolution.component.html',
  styleUrls: ['./stats-evolution.component.scss'],
  standalone: false,
})
export class StatsEvolutionComponent implements OnInit {
  sidenav: MatSidenav;
  loggedUser: any;
  groups: Array<any> = [];
  groupSelected: string = 'general';
  positionEvolutionLabels: string[] = [];
  positionEvolutionSeries: Array<any> = [];
  pointsEvolutionLabels: string[] = [];
  pointsEvolutionSeries: Array<any> = [];

  constructor(
    private sidenavService: SidenavService,
    private authService: AuthService,
    private groupsService: GroupsService,
    private localService: LocalService,
    private standingsService: StandingsService,
    private router: Router,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
    this.loggedUser = this.authService.getUser();
  }

  async ngOnInit() {
    this.groups = await this.groupsService.getList();
    this.groupSelected =
      (await this.localService.getDataV2<string>('stgrsel')) || 'general';
    await this.loadEvolution();
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  goBack() {
    this.router.navigate(['/stats']);
  }

  async selectGroup(groupId: string) {
    this.groupSelected = groupId;
    await this.localService.saveDataV2('stgrsel', this.groupSelected);
    await this.loadEvolution();
  }

  private async loadEvolution() {
    const standingsGroupId =
      this.groupSelected === 'general' ? undefined : this.groupSelected;
    const response = await this.standingsService.getEvolution(standingsGroupId);
    const standingsEvolution = response?.standingsEvolution || [];
    const pointsEvolution = response?.pointsEvolution || [];

    const trackedUsers = this.getTrackedUsers(
      standingsEvolution[standingsEvolution.length - 1] ||
        pointsEvolution[pointsEvolution.length - 1] ||
        [],
    );

    const positionChart = this.buildPositionEvolution(
      standingsEvolution,
      trackedUsers,
    );
    this.positionEvolutionLabels = positionChart.labels;
    this.positionEvolutionSeries = positionChart.series;

    const pointsChart = this.buildPointsEvolution(pointsEvolution, trackedUsers);
    this.pointsEvolutionLabels = pointsChart.labels;
    this.pointsEvolutionSeries = pointsChart.series;
  }

  private getTrackedUsers(currentJourney: any[]): any[] {
    if (!currentJourney.length) {
      return [];
    }

    const trackedUsers = currentJourney
      .slice(0, 5)
      .map((standing: any) => standing.user);
    const containsLoggedUser = trackedUsers.some(
      (user: any) => user._id === this.loggedUser?._id,
    );

    if (!containsLoggedUser) {
      const meStanding = currentJourney.find(
        (standing: any) => standing.user._id === this.loggedUser?._id,
      );
      if (meStanding?.user) {
        trackedUsers.push(meStanding.user);
      }
    }

    return trackedUsers;
  }

  private buildPositionEvolution(evolution: any[], trackedUsers: any[]) {
    if (!evolution.length || !trackedUsers.length) {
      return {
        labels: [],
        series: [],
      };
    }

    return {
      labels: evolution.map((_: any, index: number) => `J${index + 1}`),
      series: trackedUsers.map((user: any) => ({
        label: user.name || user.email,
        data: evolution.map((journey: any[]) => {
          const position = journey.findIndex(
            (item: any) => item.user._id === user._id,
          );
          return position === -1 ? null : position + 1;
        }),
        highlight: user._id === this.loggedUser?._id,
      })),
    };
  }

  private buildPointsEvolution(evolution: any[], trackedUsers: any[]) {
    if (!evolution.length || !trackedUsers.length) {
      return {
        labels: [],
        series: [],
      };
    }

    return {
      labels: evolution.map((_: any, index: number) => `J${index + 1}`),
      series: trackedUsers.map((user: any) => ({
        label: user.name || user.email,
        data: evolution.map((journey: any[]) => {
          const standing = journey.find((item: any) => item.user._id === user._id);
          return typeof standing?.points === 'number' ? standing.points : null;
        }),
        highlight: user._id === this.loggedUser?._id,
      })),
    };
  }
}
